export default __webpack_public_path__ + "static/media/Home Textiles 2.eca98bb7.jpg";